import ApiRequest from 'EurestoApi/ApiRequest'
import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'

const project = require('EurestoConfig/project.config')


export default async () => {
  return new Promise(async resolve => {
    const result = await ApiRequest(project.api + 'commun', {
      requete: 'data',
      action: 'list'
    }, {
      showAlertError: false,
      onDownloadProgress: progress => {
        let percentCompleted = Math.floor((progress.loaded * 100) / progress.total)
        $('#MainBlockProgress').css('width', (148 * percentCompleted) / 100)
          .css('transition-duration', '250ms')
      },
    })
    //await Utils.sleep(800);

    if (result !== undefined) {
      if ((!result.user || !result.user.profils_web || result.user.profils_web.length === 0) && (!result.user || result.user.type !== 1)) {
        return User.Disconnect()
      }

      if (result.user.type !== 1 && result.user.profils_web && result.user.profils_web.length === 1) {
        const UserProfilWeb = result.user.profils_web[0]

        if (UserProfilWeb) {
          result.user.profil_id = UserProfilWeb.profil_id
          result.user.profil_v2_id = UserProfilWeb.profil_v2_id
        }
      }

      User.User.set(result.user)
      User.Entite.set(result.entite)

      const datas = result.results

      Data.init(datas)
    } else return User.Disconnect()

    resolve()
  })
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Data/Download.js